import { render } from "./colorPicker.vue?vue&type=template&id=004a8aeb&scoped=true&ts=true"
import script from "./colorPicker.vue?vue&type=script&lang=ts"
export * from "./colorPicker.vue?vue&type=script&lang=ts"

import "./colorPicker.vue?vue&type=style&index=0&id=004a8aeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004a8aeb"]])

export default __exports__